import { ToastError, ToastSuccess } from 'components/Toaster';
import { GobackButton, PrimaryButton, YellowButton } from 'components/UI/Buttons';
import { CertificacoesService } from 'core/http/service/Certificacoes.service';
import AdminRecursosCostumizados from 'core/http/service/admin/AdminRecursosCostumizados.service';
import { FadCoursesService } from 'core/http/service/ferramentaAutoria/FadCourses.service';
import Colors from 'enums/Colors';
import { TipoCertificacaoEnum } from 'enums/TipoCertificacaoEnum';
import { Formik } from 'formik';
import { values } from 'lodash';
import { CertificacoesModel } from 'models/certificacoes/CertificacoesModel';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';
import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import * as yup from 'yup';
import html2pdf from 'html2pdf.js';

import { Button, Divider } from 'antd';

interface IModalCreateCertificated {
    open: boolean;
    handleHide: () => void;
    isReloading: () => void;
    dados?: CertificacoesModel | null;
}

interface typeValues {
    nome: string;
    textoSolicitacao: string;
    precisaSolicitar: boolean;
    certificateTemplateInternal: boolean;
    filepathCertificateInternal?: string;
    nomeFilepath?: string;
    link: string;
    type?: TipoCertificacaoEnum;
    itemRecursoCustomizadoCodigo?: number;
    ferramentaAutoriaCursoCodigo?: number;
    cargaHoraria?: number;
}

const InitialValues: typeValues = {
    nome: '',
    textoSolicitacao: '',
    precisaSolicitar: true,
    certificateTemplateInternal: false,
    filepathCertificateInternal: '',
    nomeFilepath: '',
    link: '',
    type: TipoCertificacaoEnum.RECURSO,
    itemRecursoCustomizadoCodigo: undefined,
    ferramentaAutoriaCursoCodigo: undefined,
    cargaHoraria: undefined,
};

interface TypeBase64File {
    nome: string;
    base64: string;
}

const serviceCertificacoes = new CertificacoesService();

const ModalCreateCertificated = ({ open, handleHide, isReloading, dados }: IModalCreateCertificated) => {
    const [formValues, setFormValues] = useState<typeValues>(InitialValues);
    const [editCertificated, setEditCertificated] = useState<boolean>(false);
    const [draftDados, setDraftDados] = useState<CertificacoesModel | null>(null);
    const [textSolicitacao, setTextSolicitacao] = useState<string>(dados?.textoSolicitacao ?? '');
    const [certificateFileCapa, setCertificateFileCapa] = useState<TypeBase64File | null>(null);
    const [certificateFileVerso, setCertificateFileVerso] = useState<TypeBase64File | null>(null);
    const [removedCapa, setRemovedCapa] = useState<boolean>(false);
    const [removedVerso, setRemovedVerso] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [loadingTest, setLoadingTest] = useState<boolean>(false);
    const [recursosCostumizados, setRecursosCostumizados] = useState<any[]>([]);
    const [cursosFerramenta, setCursosFerramenta] = useState<any[]>([]);

    const service = new CertificacoesService();
    const adminRecursosService = new AdminRecursosCostumizados();
    const fadCoursesService = new FadCoursesService();

    const fetchRecursosAndCursos = async () => {
        try {
            // Buscar recursos customizados
            const recursosResponse = await adminRecursosService.buscarListaResumidaItemAll();
            if (recursosResponse && recursosResponse.data) {
                setRecursosCostumizados(recursosResponse.data);
            }

            // Buscar cursos da ferramenta autoria
            const cursosResponse = await fadCoursesService.findAllFadCourses();
            if (cursosResponse && cursosResponse.data) {
                setCursosFerramenta(cursosResponse.data);
            }
        } catch (error) {
            console.error('Erro ao buscar recursos e cursos:', error);
        }
    };

    const validatedForm = (values: typeValues): boolean => {
        if (values.nome.length === 0 || values.nome.length < 3) {
            console.log('Validação falhou: Nome inválido', { nome: values.nome, length: values.nome.length });
            return false;
        }
        if (values.precisaSolicitar && (textSolicitacao.length === 0 || textSolicitacao.length < 10)) {
            console.log('Validação falhou: Texto solicitação inválido', { textSolicitacao, length: textSolicitacao.length });
            return false;
        }
        if (!values.precisaSolicitar && !values.certificateTemplateInternal && (values.link.length === 0 || values.link.length < 10)) {
            console.log('Validação falhou: Link inválido', { link: values.link, length: values.link.length });
            return false;
        }
        if (values.certificateTemplateInternal && !(certificateFileCapa || dados?.certificateTemplateInternal)) {
            console.log('Validação falhou: Certificado interno selecionado mas arquivo não foi enviado', { certificateFileCapa });
            return false;
        }

        if (values.certificateTemplateInternal) {
            if (values.type === TipoCertificacaoEnum.RECURSO && !values.itemRecursoCustomizadoCodigo) {
                console.log('Validação falhou: Recurso customizado não selecionado');
                return false;
            }
            if (values.type === TipoCertificacaoEnum.FERRAMENTA_AUTORIA && !values.ferramentaAutoriaCursoCodigo) {
                console.log('Validação falhou: Curso da ferramenta autoria não selecionado');
                return false;
            }
        }

        return true;
    };

    const handleCertificateFileUpload = (event: React.ChangeEvent<HTMLInputElement>, type: 'capa' | 'verso') => {
        const file = event.target.files?.[0];

        if (file) {
            // Validar se é uma imagem (JPG, JPEG, PNG)
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            const validExtensions = ['.jpg', '.jpeg', '.png'];

            const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();

            if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                ToastError('Por favor, selecione uma imagem válida (JPG, JPEG ou PNG)');
                return;
            }

            // Validar tamanho máximo (ex: 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                ToastError('O arquivo não deve exceder 10MB');
                return;
            }

            const reader = new FileReader();

            reader.onload = e => {
                const base64String = e.target?.result as string;
                // Remove o prefixo "data:...;base64," para manter apenas a string base64 pura
                const cleanBase64 = base64String.split(',')[1] || base64String;

                if (type === 'capa') {
                    setCertificateFileCapa({
                        nome: file.name,
                        base64: cleanBase64,
                    });
                    setRemovedCapa(false);
                } else if (type === 'verso') {
                    setCertificateFileVerso({
                        nome: file.name,
                        base64: cleanBase64,
                    });
                    setRemovedVerso(false);
                }
            };

            reader.onerror = () => {
                ToastError('Erro ao processar o arquivo');
            };

            reader.readAsDataURL(file);
        }
    };

    const onSubmitHandler = async (values: typeValues) => {
        try {
            setLoadingSubmit(true);

            const valid = validatedForm(values);

            if (valid) {
                const data: CertificacoesModel = new CertificacoesModel().fromJSON({
                    nome: values.nome,
                    textoSolicitacao: textSolicitacao,
                    precisaSolicitar: values.precisaSolicitar,
                    link: values.link,
                    base64Capa: values.certificateTemplateInternal && certificateFileCapa ? certificateFileCapa.base64 : '',
                    base64Verso: values.certificateTemplateInternal && certificateFileVerso ? certificateFileVerso.base64 : '',
                    certificateTemplateInternal: values.certificateTemplateInternal,
                    // usar draftDados em vez de dados para manter isolamento
                    filepathCapa: values.certificateTemplateInternal
                        ? certificateFileCapa
                            ? '' // novo upload substitui
                            : removedCapa
                            ? '' // removido explicitamente
                            : draftDados?.filepathCapa ?? ''
                        : '',
                    filepathVerso: values.certificateTemplateInternal
                        ? certificateFileVerso
                            ? ''
                            : removedVerso
                            ? ''
                            : draftDados?.filepathVerso ?? ''
                        : '',
                    type: values.certificateTemplateInternal ? values.type : undefined,
                    itemRecursoCustomizadoCodigo:
                        values.certificateTemplateInternal && values.type === TipoCertificacaoEnum.RECURSO
                            ? parseInt(values.itemRecursoCustomizadoCodigo?.toString() ?? '0')
                            : undefined,
                    ferramentaAutoriaCursoCodigo:
                        values.certificateTemplateInternal && values.type === TipoCertificacaoEnum.FERRAMENTA_AUTORIA
                            ? parseInt(values.ferramentaAutoriaCursoCodigo?.toString() ?? '0')
                            : undefined,
                    cargaHoraria: values.certificateTemplateInternal ? values.cargaHoraria : undefined,
                });

                if (editCertificated) {
                    const response = await service.updateCertificated(dados?.codigo ?? -1, data);

                    if (response.status === 200) {
                        ToastSuccess('Certificação atualizada com sucesso!');
                        isReloading();
                        hidenModal();
                    }
                } else {
                    const response = await service.inserir(data);

                    if (response.status === 201) {
                        ToastSuccess('Certificação criada com sucesso!');
                        isReloading();
                        hidenModal();
                    }
                }
            } else {
                ToastError('Informações incorretas ou faltantes!');
            }
        } catch (error) {
            ToastError('Ocorreu um erro ao salvar a certificação!');
            console.error('Erro ao salvar certificação:', error);
        } finally {
            setLoadingSubmit(false);
        }
    };

    const hidenModal = () => {
        setFormValues(InitialValues);
        setCertificateFileCapa(null);
        setCertificateFileVerso(null);
        setRemovedCapa(false);
        setRemovedVerso(false);
        setDraftDados(null);
        handleHide();
    };

    // *** Adicionado em refatoração de 'certificado de teste' ***
    // Este manipulador constrói um objeto de dados de modelo usando os valores
    // atuais do formulário (quando disponíveis) e imagens carregadas. Ele faz
    // uma chamada para o serviço HTTP que retorna um PDF de exemplo, então força
    // o navegador a iniciar o download do arquivo. Verificações de segurança
    // evitam acessos a propriedades indefinidas e exigem que a imagem de capa
    // esteja presente.
    const handleClickCertificado = async () => {
        try {
            if (!certificateFileCapa && !(editCertificated && (draftDados?.base64Capa || draftDados?.filepathCapa))) {
                ToastError('Por favor, selecione a imagem da CAPA do certificado');
                return;
            }

            setLoadingTest(true);

            const today = new Date();
            const testData: any = {
                nomeCompleto: 'NOME DO USUÁRIO TESTE',
                tituloCurso: formValues && formValues.nome ? formValues.nome : 'CURSO TESTE',
                cargaHoraria: formValues && formValues.cargaHoraria ? formValues.cargaHoraria : 12,
                dataInicio: today.toISOString().split('T')[0],
                dataConclusao: today.toISOString().split('T')[0],
            };

            if (certificateFileCapa && certificateFileCapa.base64) {
                testData.base64Capa = certificateFileCapa.base64;
            } else if (!removedCapa && draftDados?.base64Capa) {
                testData.base64Capa = draftDados.base64Capa;
            } else if (!removedCapa && draftDados?.filepathCapa) {
                testData.filepathCapa = draftDados.filepathCapa;
            }

            if (certificateFileVerso && certificateFileVerso.base64) {
                testData.base64Verso = certificateFileVerso.base64;
            } else if (!removedVerso && draftDados?.base64Verso) {
                testData.base64Verso = draftDados.base64Verso;
            } else if (!removedVerso && draftDados?.filepathVerso) {
                testData.filepathVerso = draftDados.filepathVerso;
            }

            // Chamar serviço para gerar certificado de teste
            const response = await service.generateTestCertificate(testData);

            if (response && response.data) {
                // Fazer download do PDF
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `certificado_teste_${Date.now()}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                ToastSuccess('Certificado de teste gerado e baixado com sucesso!');
            }
        } catch (error) {
            console.error('Erro ao gerar certificado de teste:', error);
            ToastError('Erro ao gerar certificado de teste. Verifique os dados preenchidos.');
        } finally {
            setLoadingTest(false);
        }
    };

    const validateDados = async () => {
        setEditCertificated(false);
        setCertificateFileCapa(null);
        setCertificateFileVerso(null);
        setRemovedCapa(false);
        setRemovedVerso(false);

        if (dados && dados !== null) {
            // criar cópia isolada dos dados que será mantida localmente
            setDraftDados(dados);

            const newDados: typeValues = {
                nome: dados.nome || '',
                textoSolicitacao: dados.textoSolicitacao || '',
                precisaSolicitar: dados.precisaSolicitar || false,
                link: dados.link || '',
                certificateTemplateInternal: dados.certificateTemplateInternal || false,
                type: dados.type || TipoCertificacaoEnum.RECURSO,
                itemRecursoCustomizadoCodigo: dados.itemRecursoCustomizadoCodigo || undefined,
                ferramentaAutoriaCursoCodigo: dados.ferramentaAutoriaCursoCodigo || undefined,
                cargaHoraria: dados.cargaHoraria || undefined,
            };
            setEditCertificated(true);
            setFormValues(newDados);
            setTextSolicitacao(dados.textoSolicitacao || '');

            // se estiver editando e já houver imagem armazenada, não tenta baixar
            // nada – o botão de teste será habilitado apenas pela presença de filepath.
            if (dados.certificateTemplateInternal) {
                if (dados.base64Capa) {
                    setCertificateFileCapa({ nome: 'arquivo existente', base64: dados.base64Capa });
                }
                if (dados.base64Verso) {
                    setCertificateFileVerso({ nome: 'arquivo existente', base64: dados.base64Verso });
                }
            }
        } else {
            setFormValues(InitialValues);
            setDraftDados(null);
        }
    };

    useEffect(() => {
        validateDados();
        if (open) {
            fetchRecursosAndCursos();
        }
    }, [open]);

    useEffect(() => {
        setTextSolicitacao(dados?.textoSolicitacao ?? '');
    }, [dados]);

    return (
        <Modal show={open} onHide={hidenModal} size="lg" aria-labelledby="contained-modal-title-vcenter" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">{editCertificated ? 'Editar' : 'Criar'} nova certificação</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik onSubmit={() => {}} initialValues={formValues} enableReinitialize={true}>
                    {({ handleSubmit, handleChange, values, touched, errors }) => (
                        <Form>
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                name="precisaSolicitar"
                                label="O usuário precisa esperar a emissão da certificação?"
                                checked={values.precisaSolicitar}
                                onClick={handleChange}
                                disabled={values.certificateTemplateInternal}
                            />
                            <Form.Check
                                type="switch"
                                id="custom-switch-internal"
                                name="certificateTemplateInternal"
                                label="Gerar certificado internalmente?"
                                style={{ marginTop: '20px' }}
                                checked={values.certificateTemplateInternal}
                                onClick={handleChange}
                                disabled={values.precisaSolicitar}
                            />
                            <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlInput1">
                                <Form.Label className="mb-2">Nome da certificação:</Form.Label>
                                <Form.Control
                                    key={`nome-${errors.nome}`}
                                    name="nome"
                                    value={values.nome}
                                    onChange={handleChange}
                                    isValid={touched.nome && !errors.nome}
                                    type="text"
                                    placeholder="Exemplo: MEC"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label className="mb-2">Texto que vai aparecer quando o usuário solicitar a emissão:</Form.Label>
                                <ReactQuill
                                    style={{ marginTop: '20px', backgroundColor: !values.precisaSolicitar ? Colors.Grey6 : Colors.White }}
                                    theme="snow"
                                    modules={editorConfig.modules2}
                                    formats={editorConfig.formats2}
                                    readOnly={!values.precisaSolicitar}
                                    value={textSolicitacao}
                                    onChange={val => {
                                        setTextSolicitacao(val);
                                    }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlInput1">
                                <Form.Label className="mb-2">Url para o redirecionamento:</Form.Label>
                                <Form.Control
                                    name="link"
                                    value={values.precisaSolicitar || values.certificateTemplateInternal ? '' : values.link}
                                    disabled={values.precisaSolicitar || values.certificateTemplateInternal}
                                    onChange={handleChange}
                                    isValid={touched.link && !errors.link}
                                    type="text"
                                    placeholder="Exemplo: https://instituicao.com.br/emitir-certificado"
                                />
                            </Form.Group>

                            {values.certificateTemplateInternal && (
                                <>
                                    <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlSelect1">
                                        <Form.Label className="mb-2">Tipo de Certificação:</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="type"
                                            value={values.type || TipoCertificacaoEnum.RECURSO}
                                            onChange={handleChange}
                                        >
                                            <option value={TipoCertificacaoEnum.RECURSO}>Recurso Customizado</option>
                                            <option value={TipoCertificacaoEnum.FERRAMENTA_AUTORIA}>Ferramenta Autoria</option>
                                        </Form.Control>
                                    </Form.Group>

                                    {values.type === TipoCertificacaoEnum.RECURSO && (
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlSelect2">
                                            <Form.Label className="mb-2">Selecione o Recurso Customizado:</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="itemRecursoCustomizadoCodigo"
                                                value={values.itemRecursoCustomizadoCodigo || ''}
                                                onChange={handleChange}
                                            >
                                                <option value="">-- Selecione um recurso --</option>
                                                {recursosCostumizados.map((recurso: any) => (
                                                    <option key={recurso.codigo} value={recurso.codigo}>
                                                        {recurso.nome || recurso.title || `Item #${recurso.codigo}`}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    )}

                                    {values.type === TipoCertificacaoEnum.FERRAMENTA_AUTORIA && (
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlSelect3">
                                            <Form.Label className="mb-2">Selecione o Curso:</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="ferramentaAutoriaCursoCodigo"
                                                value={values.ferramentaAutoriaCursoCodigo || ''}
                                                onChange={handleChange}
                                            >
                                                <option value="">-- Selecione um curso --</option>
                                                {cursosFerramenta.map((curso: any) => (
                                                    <option key={curso.codigo} value={curso.codigo}>
                                                        {curso.nome || curso.name || `Curso #${curso.codigo}`}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    )}
                                </>
                            )}

                            {values.certificateTemplateInternal && (
                                <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlInput1">
                                    <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label className="mb-2">Carga Horaria:</Form.Label>
                                        <Form.Control
                                            key={`carga-${errors.cargaHoraria}`}
                                            name="cargaHoraria"
                                            value={values.cargaHoraria || ''}
                                            onChange={handleChange}
                                            isValid={touched.cargaHoraria && !errors.cargaHoraria}
                                            type="number"
                                            placeholder="Quantidade de horas"
                                        />
                                    </Form.Group>
                                    <Divider />
                                    <Form.Label className="mb-2">
                                        Upload do template do certificado <strong>CAPA</strong>: (JPG, JPEG, PNG)
                                    </Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept=".jpeg,.jpg,.png"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCertificateFileUpload(e, 'capa')}
                                        isValid={certificateFileCapa !== null}
                                    />
                                    {!certificateFileCapa && draftDados?.certificateTemplateInternal && !removedCapa && (
                                        <>
                                            {draftDados?.filepathCapa && (
                                                <small className="d-block mt-2" style={{ color: '#28a745' }}>
                                                    ✓ Arquivo selecionado: {draftDados?.filepathCapa}{' '}
                                                    <a
                                                        href="#"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setRemovedCapa(true);
                                                        }}
                                                        style={{ color: Colors.DeleteRed, marginLeft: 8 }}
                                                    >
                                                        remover
                                                    </a>
                                                </small>
                                            )}
                                        </>
                                    )}
                                    {certificateFileCapa && (
                                        <small className="d-block mt-2" style={{ color: Colors.DeleteRed }}>
                                            <a
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setCertificateFileCapa(null);
                                                    setRemovedCapa(true);
                                                }}
                                            >
                                                Remover arquivo
                                            </a>
                                        </small>
                                    )}
                                    <Divider />
                                    <Form.Label className="mb-2">
                                        Upload do template do certificado <strong>VERSO</strong>: (JPG, JPEG, PNG)
                                    </Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept=".jpeg,.jpg,.png"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCertificateFileUpload(e, 'verso')}
                                        isValid={certificateFileVerso !== null}
                                    />
                                    {!certificateFileVerso && draftDados?.certificateTemplateInternal && !removedVerso && (
                                        <>
                                            {draftDados?.filepathVerso && (
                                                <small className="d-block mt-2" style={{ color: '#28a745' }}>
                                                    ✓ Arquivo selecionado: {draftDados?.filepathVerso}{' '}
                                                    <a
                                                        href="#"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setRemovedVerso(true);
                                                        }}
                                                        style={{ color: Colors.DeleteRed, marginLeft: 8 }}
                                                    >
                                                        remover
                                                    </a>
                                                </small>
                                            )}
                                        </>
                                    )}
                                    {certificateFileVerso && (
                                        <small className="d-block mt-2" style={{ color: Colors.DeleteRed }}>
                                            <a
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setCertificateFileVerso(null);
                                                    setRemovedVerso(true);
                                                }}
                                            >
                                                Remover arquivo
                                            </a>
                                        </small>
                                    )}

                                    {/* botão adicionado para permitir que o usuário gere um PDF de
                                        certicado de teste antes de salvar a configuração. Ele reutiliza
                                        o mesmo handler que constrói os dados e chama o serviço.
                                        Desabilitado enquanto não houver capa selecionada. */}
                                    <Button
                                        onClick={handleClickCertificado}
                                        style={{ marginTop: '20px' }}
                                        loading={loadingTest}
                                        disabled={
                                            loadingTest ||
                                            (!certificateFileCapa &&
                                                !(editCertificated && (draftDados?.base64Capa || draftDados?.filepathCapa) && !removedCapa))
                                        }
                                    >
                                        Download Certificado (Teste)
                                    </Button>
                                </Form.Group>
                            )}

                            <div id="element-certificado" />

                            <Modal.Footer>
                                <GobackButton
                                    type="button"
                                    style={{
                                        width: '32px',
                                    }}
                                    onClick={hidenModal}
                                >
                                    Voltar
                                </GobackButton>
                                <PrimaryButton onClick={() => onSubmitHandler(values)} type="button">
                                    Salvar
                                </PrimaryButton>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default ModalCreateCertificated;
